<template>
  <base-list-item class="to-do-contact-item">
    <profile-picture
      class="profile-picture"
      :profilePicture="contact ? contact.profilePicture : ' '"
    />
    <h5 v-if="contact">
      {{ contact.given_name + " " + contact.family_name }}
    </h5>
  </base-list-item>
</template>
<script>
import BaseListItem from "../BaseListItem.vue";
import ProfilePicture from "../ListItemComponents/ProfilePicture.vue";
export default {
  components: {
    ProfilePicture,
    BaseListItem,
  },
  props: ["contact"],
};
</script>
<style scoped>
.to-do-contact-item {
  display: flex;
  align-items: center;
  margin: 10px 0px 10px 10px;
  padding: 5px;
  height: 35px;
}

.to-do-contact-item::before {
  content: "";
  position: absolute;
  left: -10px;
  top: -10%;
  height: 120%;
  border-left: 1px solid var(--contrastColor);
  color: var(--contrastColor);
}

.profile-picture {
  margin: 10px;
}

h5 {
  font-size: 0.75rem;
}
</style>
